import api from './api';

export interface Student {
  id?: number;
  company?: number;
  company_name?: string;
  first_name: string;
  last_name: string;
  father_name: string;
  full_name?: string;
  fin_code: string;
  id_number: string;
  birth_date: string;
  phone_number?: string;
  age?: number;
  // Ödəniş sahələri
  course_start_date?: string;
  course_end_date?: string;
  monthly_fee?: number;
  student_status?: 'aktiv' | 'passiv' | 'mezun' | 'donmuş';
  payment_status?: 'ödənilib' | 'gecikir' | 'gözləyir';
  last_payment_date?: string;
  next_payment_due?: string;
  days_until_payment?: number;
  payment_priority?: number;
  created_at?: string;
  updated_at?: string;
  // İmtahan paneli hesabı
  exam_panel_access?: boolean;
  exam_username?: string;
  exam_password?: string;
}

export interface StudentFilters {
  search?: string;
  company?: number;
  student_status?: string;
  payment_status?: string;
}

export interface StudentStatistics {
  total_students: number;
  active_students: number;
  monthly_revenue: Array<{
    month: string;
    month_number: number;
    revenue: number;
    year: number;
  }>;
  available_years: number[];
}

export const studentAPI = {
  // Tələbələrin siyahısını al
  getStudents: async (filters?: StudentFilters): Promise<{ success: boolean; data?: Student[]; message?: string }> => {
    try {
      const params = new URLSearchParams();
      if (filters?.search) params.append('search', filters.search);
      if (filters?.company) params.append('company', filters.company.toString());

      const response = await api.get(`/students/?${params.toString()}`);
      return { success: true, data: response.data };
    } catch (error: any) {
      console.error('Students API Error:', error.response?.data);
      return { 
        success: false, 
        message: error.response?.data?.message || error.response?.data?.detail || 'Tələbələr yüklənmədi' 
      };
    }
  },

  // Tələbə əlavə et
  createStudent: async (student: Student): Promise<{ success: boolean; data?: Student; message?: string; errors?: any }> => {
    try {
      const response = await api.post('/students/', student);
      return response.data;
    } catch (error: any) {
      console.error('Create Student API Error:', error.response?.data);
      return {
        success: false,
        message: error.response?.data?.message || error.response?.data?.detail || 'Tələbə əlavə edilmədi',
        errors: error.response?.data?.errors || error.response?.data
      };
    }
  },

  // Tələbə məlumatlarını yenilə
  updateStudent: async (id: number, student: Partial<Student>): Promise<{ success: boolean; data?: Student; message?: string; errors?: any }> => {
    try {
      const response = await api.put(`/students/${id}/`, student);
      return response.data;
    } catch (error: any) {
      console.error('Update Student API Error:', error.response?.data);
      return {
        success: false,
        message: error.response?.data?.message || error.response?.data?.detail || 'Tələbə məlumatları yenilənmədi',
        errors: error.response?.data?.errors || error.response?.data
      };
    }
  },

  // Tələbəni sil
  deleteStudent: async (id: number): Promise<{ success: boolean; message?: string }> => {
    try {
      const response = await api.delete(`/students/${id}/`);
      // 204 No Content status code üçün response.data boş ola bilər
      if (response.status === 204 || response.status === 200) {
        return {
          success: true,
          message: response.data?.message || 'Tələbə silindi'
        };
      }
      return response.data;
    } catch (error: any) {
      console.error('Delete Student API Error:', error.response?.data);
      return { 
        success: false, 
        message: error.response?.data?.message || error.response?.data?.detail || 'Tələbə silinmədi' 
      };
    }
  },

  // Tələbə statistikaları
  getStatistics: async (companyId?: number, year?: number): Promise<{ success: boolean; data?: StudentStatistics; message?: string }> => {
    try {
      const params = new URLSearchParams();
      if (companyId) params.append('company', companyId.toString());
      if (year) params.append('year', year.toString());
      
      const response = await api.get(`/students/statistics/?${params.toString()}`);
      return { success: true, data: response.data };
    } catch (error: any) {
      console.error('Statistics API Error:', error.response?.data);
      return { 
        success: false, 
        message: error.response?.data?.message || error.response?.data?.detail || 'Statistikalar yüklənmədi' 
      };
    }
  },
};